import { render, staticRenderFns } from "./noBook.vue?vue&type=template&id=34578dee&scoped=true&"
import script from "./noBook.vue?vue&type=script&lang=js&"
export * from "./noBook.vue?vue&type=script&lang=js&"
import style0 from "./noBook.vue?vue&type=style&index=0&id=34578dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34578dee",
  null
  
)

export default component.exports